import ServiceAssignmentRulesComponent from './service_assignment_rules.component';
import ServiceAssignmentRulesCreate from './create';
import ServiceAssignmentRulesEdit from './edit';
import ServiceAssignmentRulesAll from './all';

let ServiceAssignmentRulesModule = angular.module('serviceAssignmentRules', [
  ServiceAssignmentRulesCreate,
  ServiceAssignmentRulesEdit,
  ServiceAssignmentRulesAll
  ])

  .component('serviceAssignmentRules', ServiceAssignmentRulesComponent)

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $stateProvider
      .state('service_assignment_rules.edit', {
        url: '/edit/:id',
        component: 'serviceAssignmentRulesEdit',
        data: {
          requireACL: 'tnt_control_service_assignment_rules.edit'
        }
      })

      .state('service_assignment_rules.create', {
        url: '/create',
        component: 'serviceAssignmentRulesCreate',
        data: {
          requireACL: 'tnt_control_service_assignment_rules.create'
        }
      })

      .state('service_assignment_rules.all', {
        url: '/all/:page',
        component: 'serviceAssignmentRulesAll',
        data: {
          requireACL: 'tnt_control_service_assignment_rules.view'
        }        
      })
  })

  .name;

export default ServiceAssignmentRulesModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/service_assignment_rules/index.js